import React, { useMemo } from 'react';
import dompurify from 'dompurify';
import limitString from 'helpers/limit_string';

interface HtmlContainerProps {
  html?: string;
  limit?: number;
  linksTargetBlank?: boolean;
}

const HtmlContainer = ({ html, limit, linksTargetBlank }: HtmlContainerProps) => {
  const content = useMemo(() => {
    const data = limit ? limitString(html, limit) : html;

    if (linksTargetBlank) {
      dompurify.addHook('afterSanitizeAttributes', (node) => {
        if ('target' in node) {
          node.setAttribute('target', '_blank');
          node.setAttribute('rel', 'noopener noreferrer');
        }
      });
    }

    return dompurify.sanitize(data, { ADD_ATTR: ['target', 'alt'] });
  }, [html, limit, linksTargetBlank]);

  return <div className="html-container" dangerouslySetInnerHTML={{ __html: content }} />;
};

export default HtmlContainer;
